/**
 * This mixin is used to get Seat Charts balance.
 */
export default {
  data () {
    return {
      initialScale: null,
      initialMinScale: null,
      maxScale: null,
      originX: 0,
      originY: 0,
      autoZoom: null,
      applyAutoScale: false,
      currentScale: null,
      activeSeat: null
    }
  },

  methods: {
    // Method to handle zooming, combining common logic for zoom in and out
    adjustZoom (delta) {
      this.$refs.zoomer.setData({
        scale: delta,
        originX: this.originX,
        originY: this.originY,
        translateX: 0,
        translateY: 0
      })
      this.currentScale = delta
    },

    // Zoom in
    onZoomIn () {
      this.applyAutoScale = false
      if (this.currentScale < this.maxScale) {
        this.currentScale += 0.1
        this.adjustZoom(this.currentScale)
      }
    },

    // Zoom out
    onZoomOut () {
      this.applyAutoScale = false
      this.adjustZoom(this.initialScale)
      if (this.currentScale > this.initialScale) {
        this.adjustZoom(this.currentScale)
      } else {
        this.adjustZoom(this.initialMinScale)
      }
    },
    onEvent (eventName, e) {
      if (eventName === 'scaling') {
        this.currentScale = e.scale
      }
      if (eventName === 'startDrag') {
        if ((this.autoZoom - e.scale > 0.19) && (e.scale === this.initialScale) && (this.$q.screen.lt.sm || !this.showFullScreen)) {
          this.applyAutoScale = true
          this.handleStopDrag(e)
        } else {
          this.applyAutoScale = false
        }
      }
    },
    handleStopDrag (e) {
      if (!this.applyAutoScale) return

      const seatChart = this.$refs.seatChart?.$el?.getBoundingClientRect()
      if (!seatChart) return

      const horizoneOffsetSpace = seatChart.left
      const verticalOffsetSpace = seatChart.top

      if (event.clientX && event.clientY) {
        const clickPointX = event.clientX
        const clickPointY = event.clientY
        const clickPointXInSeatChart = (clickPointX - horizoneOffsetSpace) * (this.autoZoom - this.initialScale)
        const clickPointYInSeatChart = (clickPointY - verticalOffsetSpace) * (this.autoZoom - this.initialScale)

        setTimeout(() => {
          // add amination to auto scale
          const startScale = e.scale
          const startTranslateX = e.translateX
          const startTranslateY = e.translateY

          const targetScale = this.autoZoom
          const targetTranslateX = -clickPointXInSeatChart + e.translateX
          const targetTranslateY = this.showFullScreen && this.$q.screen.lt.sm ? clickPointXInSeatChart + e.translateY : -clickPointYInSeatChart + e.translateY

          let startTime = null
          const duration = 300

          const animate = (timestamp) => {
            if (!startTime) startTime = timestamp

            const elapsed = timestamp - startTime
            const progress = Math.min(elapsed / duration, 1) // Clamp progress to 0-1

            const interpolatedScale = startScale + progress * (targetScale - startScale)
            const interpolatedTranslateX = startTranslateX + progress * (targetTranslateX - startTranslateX)
            const interpolatedTranslateY = startTranslateY + progress * (targetTranslateY - startTranslateY)

            this.$refs.zoomer?.setData({
              scale: interpolatedScale,
              translateX: interpolatedTranslateX,
              translateY: interpolatedTranslateY
            })

            this.currentScale = targetScale

            if (progress < 1) {
              requestAnimationFrame(animate)
            } else {
              // Finalize state
              this.currentScale = targetScale
            }
          }

          requestAnimationFrame(animate)
        }, 50)
      } else {
        console.warn('Invalid event coordinates', e)
      }
    },
    resetSeatChart () {
      this.$refs.zoomer?.setData({
        scale: 1,
        originX: 0,
        originY: 0,
        translateX: 0,
        translateY: 0
      })
    },
    hoverSeat (seat) {
      this.activeSeat = seat
    }
  }
}
